// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "bfa4f4c45f45ffd13e24" + ".js";
};